import React, { useCallback } from "react";
import styled from "@emotion/styled";

import { MAINTENANCE_Z_INDEX } from "@/constants/zIndex";
import { mq } from "@/libs/react-responsive/mediaQuery";
import { color, image } from "@/theme";
import { PrimaryButton } from "@/components/ui/buttons";
import { useNavigate } from "react-router-dom";

const Container = styled.div(({ theme }) => ({
  position: "fixed",
  background: theme.color.primary01,
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  zIndex: MAINTENANCE_Z_INDEX,

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "2rem 2.4rem",

  [mq("desktop")]: {
    gap: "5rem 2.4rem",
  },
}));

const Image = styled.img(() => ({
  marginBottom: "5rem",
  width: "24rem",

  [mq("desktop")]: {
    width: "36rem",
    maxWidth: "auto",
  },
}));

const FooterImage = styled.img(() => ({
  width: "24rem",

  [mq("desktop")]: {
    width: "36rem",
  },
}));

const Text = styled.div(() => ({
  textAlign: "center",
  fontSize: "1.8rem",

  h1: {
    fontSize: "2.8rem",
  },

  [mq("desktop")]: {
    fontSize: "2.4rem",

    h1: {
      fontSize: "3.6rem",
    },
  },
}));

const MaintenancePage = () => {
  const navigate = useNavigate();

  const goToMain = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return (
    <Container>
      <FooterImage src={image.footerLogo.default} alt="사단법인 세이브더얼스" />

      <Image src={image.takeAction} alt="재활용품들고 있는 남자" />

      <Text>
        <h1>현재 서버 점검중입니다.</h1>

        <p>잠시 후 다시 방문해주세요.</p>
      </Text>

      <PrimaryButton bgColor={color.secondary02} clickEvent={goToMain}>
        메인으로
      </PrimaryButton>
    </Container>
  );
};

export default MaintenancePage;
